import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getProductsByAccountId } from "../services/nonAuthRequets";
import PaginateComponent from "./PaginateComponent";
import {
  S3_URL_PRODUCTS,
  S3_URL_VENDOR,
  DEFAULT_VENDOR_CODE,
  DEFAULT_VENDOR_IMAGE,
  DEFAULT_VENDOR_COVER_IMAGE,
} from "../utils/constants";
import ProductCards from "./ProductCards";
import LoadingComponent from "./LoadingComponent";
import NoResultsComponent from "./NoResultsComponent";
const VendorTwoDetails = () => {
  let [grid, setGrid] = useState(false);
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [numberOfElements, setNumberOfElements] = useState(0);
  const [loading, setLoading] = useState(false);
  const [vendorCode, setVendorCode] = useState("");
  const [vendorLogo, setVendorLogo] = useState("");
  const [vendorCoverImage, setVendorCoverImage] = useState("");
  //const [vendorRating, setVendorRating] = useState(0);
  const pageSize = 20;
  const vendorRating = 4.5;

  const [sort, setSort] = useState("");
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  let [active, setActive] = useState(false);
  let sidebarController = () => {
    setActive(!active);
  };

  const fetchProducts = async (page) => {
    setLoading(true);
    try {
      const response = await getProductsByAccountId(
        id,
        page,
        pageSize,
        sort,
        search
      );
      //console.log(response);
      setProducts(response.products);

      setTotalPages(response.totalPages);
      setTotalElements(response.totalElements);
      setNumberOfElements(response.numberOfElements);
      setVendorCode(
        response.vendorCode ? response.vendorCode : DEFAULT_VENDOR_CODE
      );

      setVendorLogo(
        response.vendorLogo
          ? `${S3_URL_VENDOR}${response.vendorLogo}`
          : DEFAULT_VENDOR_IMAGE
      );
      setVendorCoverImage(
        response.vendorCoverImage
          ? `${S3_URL_VENDOR}${response.vendorCoverImage}`
          : DEFAULT_VENDOR_COVER_IMAGE
      );
      //setVendorRating(response.vendorRating);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts(currentPage);
  }, [currentPage, sort, search]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleSortChange = (e) => {
    setSort(e.target.value);
    setCurrentPage(0); // Reset pagination on sort change
  };

  if (products.length === 0 && !loading) {
    return <NoResultsComponent message="No products found." />;
  }

  document.title = `Vendor Page ${vendorCode} | Bigmall`;
  // if (loading) return <p>Loading products...</p>;
  return (
    <section className="vendor-two-details">
      {/* <div className={`side-overlay ${active && "show"}`}></div> */}
      <div className="container container-lg">
        <div className="vendor-header mt-4">
          {/* Cover Image as a background */}
          <div
            className="cover-image bg-img"
            style={{
              backgroundImage: `url(${vendorCoverImage})`,
            }}
          >
            {/* Overlay with vendor details */}
            <div className="vendor-overlay d-flex justify-content-between align-items-center px-16 py-8">
              {/* Vendor Info (Logo, name, followers, rating) */}
              <div className="vendor-info d-flex align-items-center gap-16">
                <div
                  className="vendor-logo flex-shrink-0"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={vendorLogo}
                    alt="Vendor Logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="vendor-meta">
                  <h6 className="text-white fw-semibold mb-4">{vendorCode}</h6>
                  {/* <div className="vendor-followers text-xs text-white px-8 py-4 rounded">
                    480589 Followers
                  </div>
                  <div className="vendor-rating d-flex align-items-center gap-6 mt-4">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <span
                        key={index}
                        className={`text-15 fw-medium d-flex ${
                          index < Math.floor(vendorRating)
                            ? "text-warning-600"
                            : "text-gray-400"
                        }`}
                      >
                        <i className="ph-fill ph-star" />
                      </span>
                    ))}
                    <span className="text-xs fw-medium text-white">
                      {vendorRating.toFixed(1)}
                    </span>
                    <span className="text-xs fw-medium text-white">(12K)</span>
                  </div> */}
                </div>
              </div>
              {/* Action Buttons */}
              {/* <div className="vendor-actions d-flex gap-16">
                <button
                  type="button"
                  className="text-uppercase group border border-white px-16 py-8 rounded-pill text-white text-sm hover-bg-main-600 hover-text-white transition-2 flex-center gap-8"
                >
                  FOLLOW
                  <span className="text-xl d-flex">
                    <i className="ph ph-storefront" />
                  </span>
                </button>
                <button
                  type="button"
                  className="text-uppercase group border border-white px-16 py-8 rounded-pill text-white text-sm hover-bg-main-600 hover-text-white transition-2 flex-center gap-8"
                >
                  CHAT NOW
                  <span className="text-xl d-flex">
                    <i className="ph ph-storefront" />
                  </span>
                </button>
              </div> */}
            </div>
          </div>
        </div>

        {loading ? (
          <LoadingComponent message="Loading products…" />
        )  : (
          <>
            <div className="vendor-two-details__contents">
              <div className="d-flex align-items-center justify-content-between flex-wrap mt-40 mb-32 gap-16">
                <div className="container">
                  <div className="row align-items-center g-3">
                    <div className="col-12 col-md-4">
                      <input
                        type="text"
                        placeholder="Search by name"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-6 col-md-2">
                      <button
                        onClick={() => {
                          setSearch(searchInput);
                          setCurrentPage(0);
                        }}
                        disabled={searchInput.length < 3}
                        className="btn btn-danger btn-sm w-100"
                      >
                        Search
                      </button>
                    </div>
                    <div className="col-12 col-md-4">
                      <select
                        value={sort}
                        onChange={handleSortChange}
                        className="form-select"
                      >
                        <option value="">Sort By</option>
                        <option value="lowest">
                          Lowest Price to Highest Price
                        </option>
                        <option value="highest">
                          Highest Price to Lowest Price
                        </option>
                        <option value="new">New Arrivals</option>
                      </select>
                    </div>
                    <div className="col-6 col-md-2">
                      <button
                        onClick={() => {
                          setSearch("");
                          setSearchInput("");
                          setSort("");
                          setCurrentPage(0);
                        }}
                        className="btn btn-danger btn-sm w-100"
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between justify-content-sm-end gap-16 flex-grow-1">
                  <span className="text-gray-900">
                    Showing {currentPage * pageSize + 1}-
                    {Math.min((currentPage + 1) * pageSize, totalElements)} of{" "}
                    {totalElements} results
                  </span>
                </div>
              </div>
              <ProductCards
                products={products}
                currentPage={currentPage}
                totalPages={totalPages}
                showLoadmore={false}
                margin_top="product"
              />
            </div>
            {/* </div> */}
            <div className="container">
              <PaginateComponent
                totalPages={totalPages}
                currentPage={currentPage}
                handlePageClick={handlePageClick}
              />
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default VendorTwoDetails;
